<template>
  <v-card
    color="#CFD8DC"
  >
    <v-container
      fluid
    >
      <v-card
        v-if="!isOrganizationModuleExists"
        color="#eceff1"
      >
        <v-row>
          <v-col
            v-for="(item, index) in OrganizationModuleDetailsList"
            :key=" index"
            class="py-0 mt-2 "
            cols="12"
          >
            <p class="my-p-style ml-6 mt-2">
              {{ item.name.toUpperCase() }}
              <v-btn
                class=" my-btn-style mx-3 "
                absolute
                right
                color="#37474F"
                text
                @click="selectedModuleDetails(item)"
              >
                view settings
              </v-btn>
            </p>
          </v-col>
        </v-row>
        <br>
      </v-card>
      <p
        v-if="isOrganizationModuleExists"
        class="my-alert-style"
      >
        No Modules Found.
      </p>
    </v-container>
    <organization-module-setting-form
      v-if="showForm"
      :module-details="moduleDetails"
      :current-active-tab="currentActiveTab"
      @get-organization-module-details="fetchOrganizationModuleDetails"
      @closed="showForm = false;"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-card>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import OrganizationModuleSettingForm from 'src/views/dashboard/organizations/OrganizationModuleSettingForm.vue';

  export default {
    name: 'OrganizationModuleDetails',
    components: {
      'centre-spinner': spinner,
      'organization-module-setting-form': OrganizationModuleSettingForm,
    },
    data () {
      return {
        loading: false,
        showForm: false,
        showCreateForm: false,
        moduleDetails: {},
        currentActiveTab: '',
      };
    },
    computed: {
      OrganizationModuleDetailsList () {
        return this.$store.getters['organizations/getOrganizationModuleDetails'];
      },
      isOrganizationModuleExists () {
        return Object.keys(this.OrganizationModuleDetailsList).length === 0;
      },
    },
    methods: {
      async fetchOrganizationModuleDetails (val) {
        this.loading = true;
        this.currentActiveTab = val;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationModuleDetails', {
          organizationlId: organizationlId,
          appModuleName: val,
        }).then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      selectedModuleDetails (SelectedModuleDetails) {
        this.moduleDetails = SelectedModuleDetails;
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #37474F;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.icon-style {
  color: #37474F;
  font-size: 40px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.my-btn-style {
  font-weight: bold;
}
</style>
